<template>
	<a v-if="isExternalLink" :href="toAsHref">
		<slot />
	</a>
	<router-link v-else :to="toAsHref">
		<slot />
	</router-link>
</template>

<script>
import { isVueRoute, isHybridEnvironment } from "@/common/functions";
export default {
	name: "ZebraLink",
	props: {
		to: {
			type: [String, Object],
			required: true,
		},
		forceExternal: {
			type: Boolean,
			required: false,
			default: null,
		},
	},
	computed: {
		isExternalLink() {
			if (typeof this.forceExternal === "boolean") {
				return this.forceExternal;
			}

			return (
				typeof window === "object" &&
				!isVueRoute(this.toAsHref) &&
				isHybridEnvironment(window.location.origin)
			);
		},
		toAsHref() {
			if (typeof this.to === "string") {
				return this.to;
			}

			let href = this.$router.resolve(this.to).href || "";

			// We also want to make sure we correctly handle routes with query parameters.
			const questionMarkPosition = href.lastIndexOf("?");
			const shouldBeTrailingSlash =
				questionMarkPosition >= 0
					? questionMarkPosition - 1
					: questionMarkPosition;
			const lastValidChar = href
				.slice(shouldBeTrailingSlash)
				.substring(0, 1);

			if (lastValidChar !== "/") {
				href = `${href}/`;
			}

			return href;
		},
	},
};
</script>
